import { Shark, Utils, View } from "shark-mvc";
import Chart from "chart.js";

import templateContent from "../../_shark_templates/views/home.html";

import followUpManager from "../managers/followUpManager";
import { clientFullRecapComponent } from "../../views/visits/clientFullRecapComponent";
import { clientManager } from "../managers/clientManager";
import constructionSiteListView from "../../views/constructionSite/constructionSiteListView";
import followUpComponent from "../../components/followUp/followUpComponent";
import mainNavComponent from "../components/mainNavComponent";
import { permissionManager } from "../managers/permissionManager";
import { productLineManager } from "../managers/productLineManager";
import quotationListView from "./quotationListView";
import siteInfoSheetDisplayView from "../../views/site-info-sheets/siteInfoSheetDisplayView.js";
import siteInfoSheetOutdoorDisplayView from "../../views/site-info-sheets/siteInfoSheetOutdoorDisplayView.js";
import systemManager from "../managers/systemManager";
import { userManager } from "../managers/userManager.js";
import visitEditView from "../../views/visits/visitEditView";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class HomeView extends View {
	constructor () {
		super("homeView");
		this.setTemplate(templateContent);
	}

	// afterLoad () {
	// 	alert("Attenzione!! Si ricorda che dalle 18:00 del 07/10/2022 fino alle 8:00 del 10/10/2022 NON devono essere inseriti nuovi dati o modificati quelli esistenti.\n\nIn tale periodo IPM HUB può essere utilizzato solo per consultazione.\n\nNB: Eventuali dati inseriti in tale periodo andranno perduti.");
	// }

	
	afterRender () {
		const prospectRecap = Shark.get("prospectRecap");

		if (prospectRecap !== null) {
			const prospectRecapChartCanvas = document.getElementById("prospectRecapChart");
			
			if (prospectRecapChartCanvas) {
				const prospectRecapChartCTX = prospectRecapChartCanvas.getContext("2d");
				const backgroundColor = [
					"#f83e3e",
					"#BBBBBB",
					"#caffc1",
				];

				const completionData = {
					datasets: [
						{
							data: Object.values(prospectRecap),
							backgroundColor: backgroundColor,
						},
					],
					labels: [
						" In ritardo: " + prospectRecap.expired,
						" Non assegnati: " + prospectRecap.notAssigned,
						" In attesa: " + prospectRecap.pending,
					]
				};
				var prospectRecapChart = new Chart(prospectRecapChartCTX, {
					data: completionData,
					options: {
						animation: {
							animateRotate: false
						},	
						legend: {
							position: "right"
						},
						tooltips: {
							callbacks: {
								label: function(tooltipItem, data) {
									return data.labels[tooltipItem.index];
								}
							}
						}		
					},
					type: "pie",
				});
			}
		}

		
		const siteInfoSheetRecap = Shark.get("siteInfoSheetRecap");

		if (siteInfoSheetRecap !== null) {
			const siteInfoSheetRecapChartCanvas = document.getElementById("siteInfoSheetRecapChart");
			
			if (siteInfoSheetRecapChartCanvas) {
				const siteInfoSheetRecapChartCTX = siteInfoSheetRecapChartCanvas.getContext("2d");
				const backgroundColor = [
					"#f83e3e",
					"#ffe3aa",
					"#aae2a1",
				];

				const completionData = {
					datasets: [
						{
							data: Object.values(siteInfoSheetRecap),
							backgroundColor,
						},
					],
					labels: [
						" Da gestire: " + siteInfoSheetRecap[0],
						" Preventivo inviato: " + siteInfoSheetRecap[1],
						" Preventivo caricato: " + siteInfoSheetRecap[4],
					]
				};
				var siteInfoSheetRecapChart = new Chart(siteInfoSheetRecapChartCTX, {
					data: completionData,
					options: {
						animation: {
							animateRotate: false
						},	
						legend: {
							position: "right"
						},
						tooltips: {
							callbacks: {
								label: function(tooltipItem, data) {
									return data.labels[tooltipItem.index];
								}
							}
						}		
					},
					type: "pie",
				});
			}
		}

		
		const quotationRecap = Shark.get("quotationRecap");

		if (quotationRecap !== null) {
			const quotationRecapChartCanvas = document.getElementById("quotationRecapChart");
			
			if (quotationRecapChartCanvas) {
				const quotationRecapChartCTX = quotationRecapChartCanvas.getContext("2d");
				const backgroundColor = [
					// "#f83e3e",
					"#ffe3aa",
					"#aae2a1",
				];

				const completionData = {
					datasets: [
						{
							data: Object.values(quotationRecap),
							backgroundColor,
						},
					],
					labels: [
						// " Da gestire: " + quotationRecap[0],
						" Preventivo inviato: " + quotationRecap[1],
						" Preventivo caricato: " + quotationRecap[4],
					]
				};
				var quotationRecapChart = new Chart(quotationRecapChartCTX, {
					data: completionData,
					options: {
						animation: {
							animateRotate: false
						},	
						legend: {
							position: "right"
						},
						tooltips: {
							callbacks: {
								label: function(tooltipItem, data) {
									return data.labels[tooltipItem.index];
								}
							}
						}		
					},
					type: "pie",
				});
			}
		}
		

		const visitRecap = Shark.get("visitRecap");

		if (visitRecap !== null) {
			const visitRecapChartCanvas = document.getElementById("visitRecapChart");
			
			if (visitRecapChartCanvas) {
				const visitRecapChartCTX = visitRecapChartCanvas.getContext("2d");
				const backgroundColor = [
					"#aae2a1",
					"#f83e3e",
					"#ffe3aa",
					"#aaa1e2",
					"#e2aaa1",
				];

				const completionData = {
					datasets: [
						{
							data: Object.values(visitRecap),
							backgroundColor,
						},
					],
					labels: [
						" Positivo effettuata visita: " + visitRecap["1"],
						" Non interessato: " + visitRecap["5"],
						" Non raggiungibile: " + visitRecap["6"],
						" Positivo visitare in futuro: " + visitRecap["future_v"],
						" Richiamare in futuro: " + visitRecap["future_p"],
					]
				};
				var visitRecapChart = new Chart(visitRecapChartCTX, {
					data: completionData,
					options: {
						animation: {
							animateRotate: false
						},	
						legend: {
							position: "right"
						},
						tooltips: {
							callbacks: {
								label: function(tooltipItem, data) {
									return data.labels[tooltipItem.index];
								}
							}
						}		
					},
					type: "pie",
				});
			}
		}
	}

	beforeLoad () {
		waitBoxComponent.show();
		// const currUser = Shark.get("currUser");
		//Lo commento perché c"è nel FU Component.. ma nn mi piace
		//userManager.getList();
		if (Shark.get("userList").length !== 0) {
			this.userManager_listChangedHandler();
		}
	}

	userManager_listChangedHandler () {
		const currUser = Shark.get("currUser");
		const requestedTypes = [];

		userManager.getRequireAttentionCounts();

		if (!Shark.get("permissionList") || Shark.get("permissionList").length === 0) {
			permissionManager.getList();
		}
		if (!Shark.get("productLineList") || Shark.get("productLineList").length === 0) {
			productLineManager.getList();
		}

		clientManager.getProspectRecap();
		clientManager.getPendingDeleteRequest();

		if (currUser.hasPermission("manageClientVisits") || currUser.hasPermission("viewVisits")) {
			requestedTypes.push("report");
		}
		if (currUser.hasPermission("manageQuotation") || currUser.hasPermission("viewQuotation")) {
			requestedTypes.push("quotation");
		}
		if (currUser.hasPermission("manageClientSolvencyRequest", "manageSiteInfoSheet", "viewSiteInfoSheet")) {
			requestedTypes.push("siteInfoSheet");
		}
		if (currUser.hasPermission("manageConstructionSiteCard") || currUser.hasPermission("viewConstructionSiteCard")) {
			requestedTypes.push("constructionSiteCard");
		}
		if (currUser.hasPermission("manageConstructionSite") || currUser.hasPermission("viewConstructionSites")) {
			requestedTypes.push("constructionSite");
		}
		if (currUser.hasPermission("editNotComplianceReportForIPM") || currUser.hasPermission("viewNotComplianceReport")) {
			requestedTypes.push("notComplianceReport");
		}

		systemManager.getLatest(requestedTypes)
		.then(getLatestResponse => {
			console.log({getLatestResponse});
			const data = getLatestResponse.data;

			waitBoxComponent.hide();
			Shark.set({
				// appointmentList: [],
				latestConstructionSiteList: data.constructionSiteList,
				latestConstructionSiteCardList: data.constructionSiteCardList,
				latestNotComplianceReportList: data.notComplianceReportList,
				latestQuotationList: data.quotationList,
				latestSiteInfoSheetList: data.siteInfoSheetList,
				siteInfoSheetRecap: data.siteInfoSheetRecap,
				latestVisitList: data.reportList,
				// pendingDeleteRequestList: [],
				// prospectRecap: null,
				quotationRecap: data.quotationRecap,
				visitRecap: data.reportRecap,
			});
		})
	}

	beforeRender () {
		const prospectRecap = Shark.get("prospectRecap");
		const quotationRecap = Shark.get("quotationRecap");
		const siteInfoSheetRecap = Shark.get("siteInfoSheetRecap");
		const visitRecap = Shark.get("visitRecap");
		let __showProspectReport = false;
		let __showQuotationReport = false;
		let __showSiteInfoSheetReport = false;
		let __showVisitReport = false;

		if (prospectRecap) {
			__showProspectReport = Object.values(prospectRecap).reduce((a, b) => a + b, 0) > 0;
		}
		if (quotationRecap) {
			__showQuotationReport = Object.values(quotationRecap).reduce((a, b) => a + b, 0) > 0;
		}
		if (siteInfoSheetRecap) {
			__showSiteInfoSheetReport = Object.values(siteInfoSheetRecap).reduce((a, b) => a + b, 0) > 0;
		}
		if (visitRecap) {
			__showVisitReport = Object.values(visitRecap).reduce((a, b) => a + b, 0) > 0;
		}
		
		this.set({
			__showProspectReport,
			__showQuotationReport,
			__showSiteInfoSheetReport,
			__showVisitReport,
		});
	}

	cancelDeleteRequestBtn_clickHandler (event, data) {
		const currClient = Utils.safp(Shark.get("pendingDeleteRequestList"), "guid", data.guid);

		if (currClient) {
			const cancelMessage = prompt(`Sei sicuro di voler annullare la richiesta di eliminazione per "${currClient.name}"?\n${currClient.__agentFullName} lo troverà fra i suoi contatti.\n\nSe vuoi puoi inserire un messaggio per l"agente (opzionale)`);

			if (cancelMessage !== null) {
				clientManager.cancelDeleteRequest(currClient)
				.then(response => {
					if (response.status === "ok") {
						const newFollowUp = followUpComponent.prepareNewFollowUp(currClient).currFollowUp;

						newFollowUp.set({
							body: "Richiesta di eliminazione annullata." + (cancelMessage !== "" ? ` Messaggio: <q>${cancelMessage}</q>` : ""),
							status: 3,
							type: "system",
						});

						followUpManager.save(newFollowUp);

						Shark.render();
					}
				});
			}
		}
	}

	confirmDeleteBtn_clickHandler (event, data) {
		const currClient = Utils.safp(Shark.get("pendingDeleteRequestList"), "guid", data.guid);

		if (currClient) {
			if (confirm(`Sei sicuro di voler eliminare "${currClient.name}"?`)) {
				clientManager.confirmDeleteRequest(currClient)
				.then(response => {
					if (response.status === "ok") {
						const newFollowUp = followUpComponent.prepareNewFollowUp(currClient).currFollowUp;

						newFollowUp.set({
							body: "Richiesta di eliminazione confermata.",
							status: 3,
							type: "system",
						});

						followUpManager.save(newFollowUp);

						Shark.render();
					}
				});
			}
		}
	}

	init () {
		this.addComponents([clientFullRecapComponent, followUpComponent, mainNavComponent, waitBoxComponent]);

		Shark.set({
			appointmentList: [],
			latestConstructionSiteList: [],
			latestConstructionSiteCardList: [],
			latestNotComplianceReportList: [],
			latestQuotationList: [],
			latestSiteInfoSheetList: [],
			latestVisitList: [],
			pendingDeleteRequestList: [],
			prospectRecap: null,
		})

		this.set({
			__htmlTitle: "Dashboard | IPM HUB"
		});
	}

	singleConstructionSite_clickHandler (event, data) {
		let currConstructionSite = Utils.safp(Shark.get("constructionSiteList"), "guid", data.guid);

		if (currConstructionSite) {
			Shark.set("hiliteConstructionSite", currConstructionSite);
			Shark.openPage(constructionSiteListView);
		}
	}

	singleQuotation_clickHandler (event, data) {
		let currQuotation = Utils.safp(Shark.get("quotationList"), "guid", data.guid);

		if (currQuotation) {
			Shark.set("hilitedQuotation", currQuotation);
			Shark.openPage(quotationListView);
		}
	}

	singleSiteInfoSheet_clickHandler (event, data) {
		if (event.target.classList.contains("notClickable")) {
			return;
		}

		const currSiteInfoSheet = Utils.safp(Shark.get("siteInfoSheetList"), "guid", data.guid);

		if (currSiteInfoSheet) {
			Shark.set({
				isEditingSiteInfoSheet: false,
				currSiteInfoSheet
			});
		
			if (currSiteInfoSheet.type === "industrial") {
				Shark.openPage(siteInfoSheetDisplayView);
			}
			else {
				Shark.openPage(siteInfoSheetOutdoorDisplayView);
			}
		}
	}

	singleVisit_clickHandler (event, data) {
		let selectedVisit = Utils.safp(Shark.get("visitList"), "guid", data.guid);
		Shark.set("currVisit", selectedVisit);
		Shark.openPage(visitEditView);
	}
}

const homeView = new HomeView();

Shark.registerView(homeView);

export { homeView };
